export default __webpack_public_path__ + "00ba5606b4d8356975367e7832c70303.svg";